var modal = document.getElementById("myModal");

var btn = document.querySelectorAll(".myBtn");

var span = document.getElementsByClassName("close")[0];
btn.forEach((userItem) => {
  userItem.onclick = function () {
    modal.style.display = "block";

    var elem = document.querySelector(".popup-carousel");
    var flkty = new Flickity(elem, {
      // options
      cellAlign: "left",
      asNavFor: ".popup-main-carousel",
      contain: true,
      lazyLoad: true,
      pageDots: false,
      prevNextButtons: false,
    });

    var elem = document.querySelector(".popup-main-carousel");
    var flkty = new Flickity(elem, {
      // options
      cellAlign: "left",
      contain: true,
      lazyLoad: true,
      pageDots: false,
      prevNextButtons: false,
    });
  };
});
span.onclick = function () {
  modal.style.display = "none";
};

window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
};
